export const formatPrice = (price: string | number) => {
  if (typeof price === 'number') {
    price = price.toString()
  }

  return parseFloat(price).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}
